import { z } from "zod";
import { CreateOrderRequestSchema, CreateOrderResponseSchema } from "../CreateOrder";

export const RecentOrderSchema = z.object({
  timestamp: z.number(),
  input: CreateOrderRequestSchema,
  output: CreateOrderResponseSchema,
  marketplace: z.string(),
  createdBy: z.string(),
});

export const RecentOrdersSchema = z.array(RecentOrderSchema);

export const RecentOrdersResponseSchema = z.object({
  recentOrders: z.array(RecentOrderSchema),
  lastTimestamp: z.number().nullable().optional(),
});

export type RecentOrder = z.infer<typeof RecentOrderSchema>;
export type RecentOrders = z.infer<typeof RecentOrdersSchema>;
export type RecentOrdersResponse = z.infer<typeof RecentOrdersResponseSchema>;
